var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"text-h6 font-weight-light"},[_vm._v("Technologies")]),(_vm.isLoading)?_c('v-skeleton-loader',{staticClass:"rounded-xl mt-5",attrs:{"type":"image","width":"400"}}):_vm._e(),_c('div',{attrs:{"id":"chart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }